export enum SearchStatusTypes {
  'SUPPLIERS_RESPONDED' = 'SUPPLIERS_RESPONDED',
  'DEALS_POST_PROCESSED' = 'DEALS_POST_PROCESSED'
}
